export const journeyCopyIt = {
    profileCompleteTitle: "Profilo completato",
    profileCompleteStatusLabel: "Profilo salvato",
    profileCompleteConsentDescription: "Le informazioni del Suo profilo sono state salvate. Passeremo ora al consenso.",
    profileCompleteSetupDescription:
        "Le informazioni del Suo profilo sono state salvate. Ora ci servono i dettagli del Suo trattamento.",
    profileCompleteFormsDescription:
        "Le informazioni del Suo profilo sono state salvate. Ora può compilare i Suoi moduli.",
    profileCompleteDiaryDescription: "Le informazioni del Suo profilo sono state salvate.",
    consentCompleteTitle: "Consenso completato",
    consentCompleteStatusLabel: "Consenso firmato",
    consentCompleteSetupDescription:
        "Grazie! I Suoi consensi sono stati registrati. Ci servono ancora alcune informazioni aggiuntive.",
    consentCompleteFormsDescription: "I Suoi consensi sono stati registrati. Ora può compilare i Suoi moduli.",
    consentCompleteDiaryDescription: "I Suoi consensi sono stati registrati.",
    setupCompleteTitle: "Configurazione completata",
    setupCompleteStatusLabel: "Configurazione salvata",
    setupCompleteConsentDescription: "Passeremo ora al consenso.",
    setupCompleteFormsDescription:
        "Grazie! Le Sue informazioni sono state salvate. Ci servono ancora alcune informazioni aggiuntive.",
    setupCompleteDiaryDescription: "I dettagli del Suo trattamento sono pronti.",
    formCompleteTitle: "Modulo completato",
    formCompleteNextDescription: "La Sua risposta è stata registrata. Può passare all'inserimento successivo.",
    formCompleteAllDoneDescription:
        "La Sua risposta è stata registrata. Per il momento è aggiornato. Può consultare i Suoi risultati.",
    formCompleteNextEntryDue: (scheduleLabel, date) =>
        `Il Suo inserimento « ${scheduleLabel.toLowerCase()} » è da effettuare il ${date}.`,
    formCompleteStatusSuffix: "completato",
    continueToNextForm: "Avanti",
    goToConsent: "Vai al consenso",
    goToSetup: "Vai alla configurazione",
    knowProcedureDateYetTitle: "Conosce già la data?",
    knowProcedureDateYetMessage:
        "Aggiunga la data del Suo intervento non appena la conosce, in modo che le domande di controllo corrispondano al Suo trattamento.",
    addProcedureDate: "Aggiungi la data dell'intervento",
    addHospitalNumber: "Aggiungi il numero di cartella clinica",
    addSide: "Aggiungi il lato",
    addEventDate: (eventPhrase) => `Aggiungi la data (${eventPhrase})`,
    reviewConsent: "Leggi il consenso",
    shortcutsHeading: "Ancora da fare:",
    goToForms: "Vai ai moduli",
    goToYourDiary: "Vai al Suo diario",
    goToYourResults: "Vai ai Suoi risultati",
    phaseProfile: "Profilo",
    phaseSetup: "Configurazione",
    phaseConsent: "Consenso",
    phaseForms: "Moduli",
    phaseDiary: "Diario",
    setupHospitalNumber: "Numero di cartella clinica",
    setupProcedureDate: "Data dell'intervento",
    setupSide: "Lato",
    loadingProgress: "Caricamento dell'avanzamento...",
    progressTitle: "Il Suo avanzamento",
    dismissProgress: "Chiudi l'avanzamento",
    currentStage: "Fase attuale",
    stepProgressAriaLabel: (stepLabel) => `Avanzamento: ${stepLabel}`,
    stepOf: "di",
    nextStep: "Prossimo passo",
    formsDoneCount: (done, total) => `Moduli completati: ${done} di ${total}`,
    diaryStillSettingUp: "Il tuo diario è ancora in fase di preparazione. Potrebbe volerci un momento.",
    tryAgain: "Riprova",
};
